import {ChangeDetectorRef, Component} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {ElementRef} from '@angular/core';
import {SubFormComponent} from '../../_subform';

/*
* Блок контактных данных специалиста
* */

@Component({
    providers: [
    ],
    selector: 'specialist-form-fields-contacts',
    templateUrl: './specialist-form-fields-contacts.component.html'
})
export class SpecialistFormFieldsContactsComponent extends SubFormComponent {

    public formGroupTemplate = this._fb.group({
        // Контактные данные
        home_address: [''],
        home_address_index: [''],
        phone: [''],
        email: [''],
    });

    constructor(public elementRef: ElementRef,
                private changeDetectionRef: ChangeDetectorRef,
                private _fb: FormBuilder) {
        super();
    }
}
